import * as React from 'react'
export const Lv = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#A2001D" d="M0 0h513v127.6H0zm0 214.4h513V342H0z" className="LV_svg__st1" />
  </svg>
)
